import React from "react";
import { string } from "prop-types";
import Alert from "@insightfulscience/atomic-react/Alert";
import Html from "@insightfulscience/smart-react/Html";

const FlashMessage = ({ text }) => (
	<Alert status="error" className="mb-4">
		<Html Tag="span">{text}</Html>
	</Alert>
);

FlashMessage.propTypes = {
	text: string,
};

export default FlashMessage;
